export enum LogLevel {
  SILENT = Infinity,
  ERROR = 50,
  INFO = 30,
  WARN = 20,
  DEBUG = 10,
}
